import { LogLevel } from '@azure/msal-browser';
import { AUTH_URL, CLIENT_ID, TENANT_ID } from "./env";

// Validate environment variables and warn if missing
if (!AUTH_URL || AUTH_URL === 'undefined') {
  console.error('CRITICAL: REACT_APP_AUTH_URL is not defined. MSAL authentication will fail.');
}
if (!CLIENT_ID || CLIENT_ID === 'undefined') {
  console.error('CRITICAL: REACT_APP_CLIENT_ID is not defined. MSAL authentication will fail.');
}
if (!TENANT_ID || TENANT_ID === 'undefined') {
  console.error('CRITICAL: REACT_APP_TENANT_ID is not defined. MSAL authentication will fail.');
}

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    // For CIAM tenants using .ciamlogin.com, use the base domain without tenant ID
    // This is the proper format for Microsoft Entra External ID (CIAM)
    authority: AUTH_URL || 'https://itvajraexternals.ciamlogin.com',
    redirectUri: window.location.origin + '/redirect',
    postLogoutRedirectUri: window.location.origin + '/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const apiScope = process.env.REACT_APP_API_SCOPE || "api://cscomply-api/api.readwrite";

export const loginRequest = {
  // Keep login to OIDC scopes so a bad/missing API consent cannot block sign-in.
  scopes: ["openid", "profile", "email"],
};

export const apiRequest = {
  scopes: [apiScope],
};
